module.exports = __webpack_public_path__ + "img/logo.29809ed2.png";